/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Embed_Captions_TitleInputs */

const en_file_export_embed_captions_title = /** @type {(inputs: File_Export_Embed_Captions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embed Captions`)
};

const fr_file_export_embed_captions_title = /** @type {(inputs: File_Export_Embed_Captions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incruster les sous-titres`)
};

const de_file_export_embed_captions_title = /** @type {(inputs: File_Export_Embed_Captions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitel einbetten`)
};

const it_file_export_embed_captions_title = /** @type {(inputs: File_Export_Embed_Captions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorpora didascalie`)
};

const ru_file_export_embed_captions_title = /** @type {(inputs: File_Export_Embed_Captions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Встроить субтитры`)
};

const es_file_export_embed_captions_title = /** @type {(inputs: File_Export_Embed_Captions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incrustar subtítulos`)
};

const zh_cn2_file_export_embed_captions_title = /** @type {(inputs: File_Export_Embed_Captions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`嵌入字幕`)
};

const ja_file_export_embed_captions_title = /** @type {(inputs: File_Export_Embed_Captions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャプションを埋め込む`)
};

const hi_file_export_embed_captions_title = /** @type {(inputs: File_Export_Embed_Captions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैप्शन एम्बेड करें`)
};

const pt_pt2_file_export_embed_captions_title = /** @type {(inputs: File_Export_Embed_Captions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorporar legendas`)
};

/**
* | output |
* | --- |
* | "Embed Captions" |
*
* @param {File_Export_Embed_Captions_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_embed_captions_title = /** @type {((inputs?: File_Export_Embed_Captions_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Embed_Captions_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_file_export_embed_captions_title(inputs)
	if (locale === "de") return de_file_export_embed_captions_title(inputs)
	if (locale === "it") return it_file_export_embed_captions_title(inputs)
	if (locale === "ru") return ru_file_export_embed_captions_title(inputs)
	if (locale === "es") return es_file_export_embed_captions_title(inputs)
	if (locale === "zh-CN") return zh_cn2_file_export_embed_captions_title(inputs)
	if (locale === "ja") return ja_file_export_embed_captions_title(inputs)
	if (locale === "hi") return hi_file_export_embed_captions_title(inputs)
	if (locale === "pt-PT") return pt_pt2_file_export_embed_captions_title(inputs)
	return en_file_export_embed_captions_title(inputs)
});